import { PayPalScriptProvider } from "@paypal/react-paypal-js";

import GadgetTrac from "./app.js";
import { GlobalState } from "./app/hooks/globalState";
import ErrorBoundary from "./app/components/ErrorBoundary";
import { UserProvider } from "./app/hooks/userContext.js";
import config from "./app/config";

const Application = (props) => {
  return (
    <PayPalScriptProvider
      options={{
        "client-id": config.PAYPAL_ID,
      }}
    >
      <GlobalState>
        <UserProvider>
          <ErrorBoundary>
          <GadgetTrac />
          </ErrorBoundary>
        </UserProvider>
      </GlobalState>
    </PayPalScriptProvider>
  );
};

export default Application;
